import moment from 'moment-timezone';

const getCurrentTimezoneDate = (timeZone: string) => moment().tz(timeZone).format('YYYY-MM-DD');

export default getCurrentTimezoneDate;
